import { GET_DASHBOARD_STATS } from '../actions.type'
import { SET_DASHBOARD_STATS } from '../mutations.type'
import MediaService from '@/services/MediaService'

const state = {
  stats: {}
}

// const getters = {
//   stats: state => state.stats
// }

const actions = {
  [GET_DASHBOARD_STATS]: ({ commit }) => {
    return new Promise((resolve, reject) => {
      MediaService.getStats()
        .then(response => {
          if (response.data) {
            if (response.data.error) {
              reject(response.data.error)
            } else if (response.data.data) {
              commit(SET_DASHBOARD_STATS, response.data.data)
              resolve()
            } else {
              reject('NO DATA')
            }
          } else {
            reject('NO RESPONSE')
          }
        })
        .catch(err => {
          reject(err)
        })
    })
  }
}

// basic mutations, showing loading, success, error to reflect the api call status and the token when loaded
const mutations = {
  [SET_DASHBOARD_STATS]: (state, data) => {
    state.stats = Object.assign({}, data)
  }
}

export default {
  state,
  // getters,
  actions,
  mutations
}
